import Image from 'next/image';

export default function TopRatedSellerBadge() {
  return (
    <div className="flex w-fit items-center gap-2 rounded-[1.1rem] border-2 border-zinc-200 px-4 py-2">
      <Image
        src="/icons/seller/top-rated.png"
        alt="Top Rated Seller"
        height={400}
        width={400}
        className="h-8 w-auto"
      />

      <span className="text-[1.4rem] font-semibold text-zinc-600">
        Top Rated Seller
      </span>
    </div>
  );
}
